import Image from 'next/image'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import SectionContainer from '~/components/LandingPage/components/section/SectionContainer'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'
import RequestDemoForm from '~/components/RequestDemo/RequestDemoForm'
import { TypographyText } from '~/core/ui/Text'
import { useClient } from '~/lib/hooks/use-is-client'

const PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none">
    <line y1="6.5" x2="13" y2="6.5" stroke="#9CA3AF" />
    <line x1="6.5" y1="2.18557e-08" x2="6.5" y2="13" stroke="#9CA3AF" />
  </svg>
)

const RequestDemoContainer: FC = () => {
  const { t } = useTranslation()
  const { isClient } = useClient()

  return (
    <LayoutLandingPage>
      <SectionContainer
        title="request_demo:title"
        description="request_demo:description"
        tagLabel="request_demo:tag"
        tagColor="bg-blue-100 text-blue-800"
        titleClassName="tablet:text-[61px] leading-[61px] tablet:max-w-[900px] my-4"
        className="pb-5 my-[64px] desktop:my-[80px]">
        <div className="relative">
          <div className="h-5 border-gray-100 border-r absolute -top-5 left-0 border-dashed" />
          <div className="w-5 border-gray-100 border-t absolute top-0 -left-5 border-dashed" />
          <div className="absolute -top-1.5 -left-1.5 z-10">{PLUS}</div>

          <div className="h-5 border-gray-100 border-r absolute -top-5 right-0 border-dashed" />
          <div className="w-5 border-gray-100 border-t absolute top-0 -right-5 border-dashed" />
          <div className="absolute -top-1.5 -right-1.5 z-10">{PLUS}</div>

          <div className="h-5 border-gray-100 border-r absolute -bottom-5 left-0 border-dashed" />
          <div className="w-5 border-gray-100 border-t absolute bottom-0 -left-5 border-dashed" />
          <div className="absolute -bottom-1.5 -left-1.5 z-10">{PLUS}</div>

          <div className="h-5 border-gray-100 border-r absolute -bottom-5 right-0 border-dashed" />
          <div className="w-5 border-gray-100 border-t absolute bottom-0 -right-5 border-dashed" />
          <div className="absolute -bottom-1.5 -right-1.5 z-10">{PLUS}</div>

          <div className="flex flex-col tablet:flex-row align-middle w-full justify-center mt-[80px] border-gray-100 border">
            <div className="relative mx-auto flex max-w-[1266px] flex-col pb-16 tablet:pb-0 desktop:grid tablet:grid desktop:grid-cols-[1fr_684px] tablet:grid-cols-[1fr_450px] tablet:flex-row">
              <div className="relative overflow-hidden flex flex-col justify-between">
                <div className="absolute left-0 right-0 bottom-0 -z-[1]">
                  <Image
                    src="/img/feature/lp/new/logo-background.png"
                    width={530}
                    height={0}
                    alt="cr_hori_line2"
                    className="w-full h-full max-w-none"
                  />
                </div>

                <div className="p-8">
                  <TypographyText className="text-lg font-medium text-gray-500 uppercase mb-6">
                    {t('request_demo:message_ceo')}
                  </TypographyText>
                  <div className="h-px w-[60px] border-dashed border-t border-gray-300" />
                  <div className="text-gray-900 text-3xl mt-6">
                    {t('request_demo:message_ceo_content')}
                  </div>
                  <div className="mt-6 flex items-center space-x-4">
                    <div className="min-w-[56px] w-[56px] h-h[56px]">
                      <Image
                        src="/img/feature/lp/new/our_leadership_01.png"
                        width={56}
                        height={56}
                        alt="ceo"
                        className="w-full h-full max-w-none"
                      />
                    </div>
                    <div>
                      <TypographyText className="text-lg font-medium text-gray-700">
                        {t('request_demo:message_ceo_name')}
                      </TypographyText>
                      <TypographyText className="text-base font-normal text-gray-600">
                        {t('request_demo:message_ceo_title')}
                      </TypographyText>
                    </div>
                  </div>
                </div>

                <div className="p-8">
                  <TypographyText className="text-gray-600 text-base font-normal">
                    {t('request_demo:slogan')}
                  </TypographyText>
                </div>
              </div>

              <div className="flex-1 border-gray-100 border-l">
                {isClient ? (
                  <RequestDemoForm
                    configText={{
                      name: 'Full name',
                      email: 'Work email',
                      company: 'Company name',
                      companySize: 'Company size',
                      title: 'Job title',
                      phone: 'Phone number',
                      country: 'Country',
                      message: 'Message',
                      submit: `${t('request_demo:submit')}`
                    }}
                    actionUrl="https://api.encharge.io/v1/forms/a1338a98-bcc7-48cf-b19a-27ef46571f4b/submission/plain"
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </SectionContainer>
    </LayoutLandingPage>
  )
}

export default RequestDemoContainer
